<form #editUserForm="ngForm" >
  <div class="modal-header">
    <h4>Edit user</h4>
    <i class="d-flex justify-content-end icon-ic_delete px-2" (click)="modalRef.hide()" style="cursor: pointer;margin-top: 8px;"></i>
  </div>
  <div class="modal-body">
    <div class="add-name">
      <strong>User name</strong>
      <input type="text" minlength="3" readonly [(ngModel)]="adduserDetails.userName" name="username" id="username"
        required>
    </div>
    <br>
    
    <!-- <div class="add-role">
      <strong>Role</strong>
      <ngx-select [items]="roleData" optionValueField="roleId" optionTextField="roleName" placeholder="Select"
      (select)="selectRole()" [(ngModel)]="RoleSelected" [noAutoComplete]="false"
       [ngModelOptions]="{standalone: true}" >
    </ngx-select>
    </div> -->
    
    <div class="add-role">
      <strong>Role</strong>
      <span class="icon-radiobutton_active icon-style" value="admin" *ngIf="selectAdminRole.isChecked"
        (click)="selectAdminRole.isChecked = true"></span>
      <span class="icon-radiobutton_inactive icon-style"  *ngIf="!selectAdminRole.isChecked"            
        (click)="setRadio('admin')"></span>
        <!-- selectSecuritySupervisorRole.isChecked = false; selectUserRole.isChecked = false  ; selectSuperAdminRole.isChecked = false; selectAdminRole.isChecked = true" -->
        
      <span>Admin</span>

      <span class="icon-radiobutton_active icon-style"  *ngIf="selectSecuritySupervisorRole.isChecked"
        (click)="selectSupervisorRole.isChecked = true" style="margin-left:10px;"></span>
      <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectSecuritySupervisorRole.isChecked" 
        style="margin-left:3px;"
        (click)="setRadio('securitysupervisor')"></span>
        <!-- selectSecuritySupervisorRole.isChecked = true; selectUserRole.isChecked = false  ; selectSuperAdminRole.isChecked = false; selectAdminRole.isChecked = false"></span> -->
      <span>Security supervisor</span> 

      <span class="icon-radiobutton_active icon-style" *ngIf="selectUserRole.isChecked"
      (click)="selectUserRole.isChecked = true" style="margin-left:10px;"></span>
      <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectUserRole.isChecked"          
      style="margin-left:6px;"
      (click)="setRadio('user')"></span>
      <!-- (click)="selectSecuritySupervisorRole.isChecked = false; selectUserRole.isChecked = true ; selectSuperAdminRole.isChecked = false; selectAdminRole.isChecked = false"></span> -->
    <span>User</span>    

    <span id="SuperAdmin" class="icon-radiobutton_active icon-style" *ngIf="selectSuperAdminRole.isChecked"
      (click)="selectSuperAdminRole.isChecked = true" style="margin-left:10px;"></span>
      <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectSuperAdminRole.isChecked"
      style="margin-left:10px;"
      (click)="setRadio('superadmin')"></span>
      <!-- (click)="selectSecuritySupervisorRole.isChecked = false; selectUserRole.isChecked = false ; selectSuperAdminRole.isChecked = true; selectAdminRole.isChecked = false"></span> -->
    <span>Super Admin</span>    

    </div>
    <br>

    <div>
      <label> 
        <input  type="checkbox" [disabled]="this.selectAdminRole.isChecked || this.selectSuperAdminRole.isChecked" [checked]= "this.selectisrequestor.isChecked" (change)= "onCheckboxChange('requestor')" style="padding-top:10% ;  margin-left: 10px;margin-top:-3px; vertical-align: middle; position: relative; "height="30px" />
        &nbsp; Requester 
      </label>
      <label>
        <input type="checkbox" [disabled]="this.selectAdminRole.isChecked || this.selectSuperAdminRole.isChecked" [checked]= "this.selectisapprover.isChecked" (change)= "onCheckboxChange('approver')" style=" margin-left:20px;  vertical-align: middle; position: relative; " height="18px" />
        &nbsp; Approver           
      </label>
     
      <label *ngIf="isApprover && (this.RoleSelected == 3 || this.RoleSelected == 4)">
        <input  type="checkbox" [disabled]="this.selectAdminRole.isChecked || this.selectSuperAdminRole.isChecked" [checked]= "this.selectisL1approver.isChecked" (change)= "onApproverChange('L1')" style="padding-top:10% ; margin-left: 15px;margin-top:-3px; vertical-align: middle; position: relative; "height="18px" />
        &nbsp; L1
      </label>
      <label *ngIf="isApprover && (this.RoleSelected == 3 || this.RoleSelected == 4)">
        <input type="checkbox" [disabled]="this.selectAdminRole.isChecked || this.selectSuperAdminRole.isChecked" [checked]= "this.selectisL2approver.isChecked" (change)= "onApproverChange('L2')" style="padding-top:10% ; margin-left: 40px;margin-top:-3px; vertical-align: middle; position: relative; "height="30px" />
        &nbsp; L2
      </label>
    </div>
    <!-- <div class="typeahead-wrap add-city">
      <strong>City</strong>
      <ngx-select [items]="cityData" optionValueField="cityId" optionTextField="cityName" placeholder="Select"
        (select)="adduserDetails.cityId" [(ngModel)]="CitySelected" [noAutoComplete]="false"
        (ngModelChange)="BindOfficeDropdown($event)" [ngModelOptions]="{standalone: true}" >
      </ngx-select>
    </div>  -->

    <!-- Requestor City and Work Location - Show only when requestor alone OR Admin/SuperAdmin, hide when requestor with approver+L1 or approver+L2 -->
    <div *ngIf="(isRequestor && !isApprover && !isL1 && !isL2) || (this.RoleSelected == 1 || this.RoleSelected == 2)">
    <div class="typeahead-wrap add-city">
      <strong>City</strong>
      <ngx-select id="cityID" name="city" [noAutoComplete]="false" [items]="cityData" [(ngModel)]="CitySelected"
        (select)="selectNewCity($event)" optionValueField="cityID" optionTextField="cityName"
         [ngModelOptions]="{standalone: true}" required>
      </ngx-select>   
    
      <div [ngClass]="{'city': selectedCity.length !== 0}">
        <div *ngFor="let item of selectedCity" style="padding-bottom:5px;">
          <div class="displayCityName">{{item.cityName}}</div>
          <i class="icon-ic_delete" style="padding-left:3px;" (click)="removeCity(item)"></i>
        </div>
      </div>  
    </div>
    
    <div class="typeahead-wrap add-office">
      <strong>Work Location</strong>
      <ngx-select id="officeID" name="office" [noAutoComplete]="false" [items]="officeData" [(ngModel)]="OfficeSelected"
       (select)="selectNewWorkLocations($event)"  optionValueField="officeID" optionTextField="officeName"
        placeholder="Select" >
      </ngx-select> 
      
      <div>
      <div [ngClass]="{'worklocaion': selectedWorklocation.length != 0}">
        <div *ngFor= "let item of selectedWorklocation;let i = index" style="padding-bottom:5px;">
            <div class="displayOfficeName">{{item.officeName}}</div><i class="icon-ic_delete" style="padding-left:3px;" (click)="removeWorkLocation($event,item)"></i>
          </div>
      </div> 
      </div> 

    </div>
    
    <!-- Practice field for Admin and Super Admin (Single Selection) -->
    <div class="add-practice" *ngIf="this.RoleSelected == 1 || this.RoleSelected == 2">
      <strong>Practice</strong>
      <ngx-select [items]="practiceMasterData" optionValueField="practiceId" optionTextField="name" 
        placeholder="Select" [(ngModel)]="PracticeSelected" 
        [noAutoComplete]="false" (ngModelChange)="Onchange_practice($event)" [ngModelOptions]="{standalone: true}">
      </ngx-select>
    </div>
    </div>
    
    <br>

    <br> 
   

    <div *ngIf="this.selectisapprover.isChecked && !isRequestor && (this.RoleSelected == 3 || this.RoleSelected == 4) && !isL1 && !isL2" class="add-practice">
      <strong>Practice</strong>
      <ngx-select id="practiceId" name="practice" [items]="practiceData" optionValueField="practiceId" optionTextField="name" placeholder="Select" 
      (select)="selectPractice()" [(ngModel)]="PracticeSelected" [noAutoComplete]="false" (ngModelChange)="Onchange_practice($event)"
       [ngModelOptions]="{standalone: true}" required>
    </ngx-select>
    
    <div [ngClass]="{'worklocaion': selectedPractice.length !== 0}">
      <div *ngFor="let item of selectedPractice; let i = index" style="padding-bottom:5px;">
        <div class="displayOfficeName">{{item.name}}</div>
        <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removePracticeSelected(item)"></i>
      </div>
    </div>
    </div>
    
    <!-- L1 and L2 Approver Sections Side by Side -->
    <div *ngIf="this.selectisapprover.isChecked && (this.RoleSelected == 3 || this.RoleSelected == 4)" style="display: flex; gap: 15px; margin-top: 15px;">
      
      <!-- L1 Approver Section (Left Side) -->
      <div *ngIf="isL1" style="flex: 1;">
        <div style="padding: 10px; background-color: #f5f5f5; border-radius: 5px; margin-bottom: 10px;">
          <h5 style="margin: 0; color: #0076A8;">L1 Approver</h5>
        </div>
        
        <!-- L1 City -->
        <div class="typeahead-wrap add-city">
          <strong>City</strong>
          <ngx-select [items]="L1cityData" optionValueField="cityID" optionTextField="cityName" 
            placeholder="Select" (select)="selectL1City()" [(ngModel)]="L1CitySelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL1City.length !== 0}">
            <div *ngFor="let item of selectedL1City" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.cityName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL1City(item)"></i>
            </div>
          </div>
        </div>

        <!-- L1 Work Location -->
        <div class="typeahead-wrap add-office">
          <strong>Work Location</strong>
          <ngx-select [items]="L1officeData" optionValueField="officeID" optionTextField="officeName" 
            placeholder="Select" (select)="selectL1WorkLocation()" [(ngModel)]="L1OfficeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL1Worklocation.length !== 0}">
            <div *ngFor="let item of selectedL1Worklocation" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.officeName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL1WorkLocation(item)"></i>
            </div>
          </div>
        </div>

        <!-- L1 Practice -->
        <div class="add-practice">
          <strong>Practice</strong>
          <ngx-select [items]="L1practiceData" optionValueField="practiceId" optionTextField="name" 
            placeholder="Select" (select)="selectL1Practice()" [(ngModel)]="L1PracticeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL1Practice.length !== 0}">
            <div *ngFor="let item of selectedL1Practice" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.name}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL1Practice(item)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- L2 Approver Section (Right Side) -->
      <div *ngIf="isL2" style="flex: 1;">
        <div style="padding: 10px; background-color: #f5f5f5; border-radius: 5px; margin-bottom: 10px;">
          <h5 style="margin: 0; color: #0076A8;">L2 Approver</h5>
        </div>
        
        <!-- L2 City -->
        <div class="typeahead-wrap add-city">
          <strong>City</strong>
          <ngx-select [items]="L2cityData" optionValueField="cityID" optionTextField="cityName" 
            placeholder="Select" (select)="selectL2City()" [(ngModel)]="L2CitySelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL2City.length !== 0}">
            <div *ngFor="let item of selectedL2City" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.cityName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL2City(item)"></i>
            </div>
          </div>
        </div>

        <!-- L2 Work Location -->
        <div class="typeahead-wrap add-office">
          <strong>Work Location</strong>
          <ngx-select [items]="L2officeData" optionValueField="officeID" optionTextField="officeName" 
            placeholder="Select" (select)="selectL2WorkLocation()" [(ngModel)]="L2OfficeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL2Worklocation.length !== 0}">
            <div *ngFor="let item of selectedL2Worklocation" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.officeName}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL2WorkLocation(item)"></i>
            </div>
          </div>
        </div>

        <!-- L2 Practice -->
        <div class="add-practice">
          <strong>Practice</strong>
          <ngx-select [items]="L2practiceData" optionValueField="practiceId" optionTextField="name" 
            placeholder="Select" (select)="selectL2Practice()" [(ngModel)]="L2PracticeSelected" 
            [noAutoComplete]="false" [ngModelOptions]="{standalone: true}">
          </ngx-select>
          
          <div [ngClass]="{'worklocaion': selectedL2Practice.length !== 0}">
            <div *ngFor="let item of selectedL2Practice" style="padding-bottom:5px;">
              <div class="displayOfficeName">{{item.name}}</div>
              <i class="icon-ic_delete" style="padding-left:3px; cursor:pointer;" (click)="removeL2Practice(item)"></i>
            </div>
          </div>
        </div>
      </div>

    </div>
    
    <div class="add-status">
      <strong>Status</strong>
      <span class="icon-radiobutton_active icon-style" *ngIf="selectActiveStatus.isChecked"
        (click)="selectActiveStatus.isChecked = true"></span>
      <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectActiveStatus.isChecked"
        (click)="selectInActiveStatus.isChecked = false ; selectActiveStatus.isChecked = true"></span>
      <span>Active</span>
      <span class="icon-radiobutton_active icon-style" *ngIf="selectInActiveStatus.isChecked"
        (click)="selectInActiveStatus.isChecked = true" style="margin-left:10px;"></span>
      <span class="icon-radiobutton_inactive icon-style" *ngIf="!selectInActiveStatus.isChecked"
        style="margin-left:10px;"
        (click)="selectInActiveStatus.isChecked = true ; selectActiveStatus.isChecked = false"></span>
      <span>Inactive</span>
    </div>
    <br>

     
    <div class="modal-footer">
    <button (click)="modalRef.hide()" type="button" class="button">
      Cancel
    </button>
    <button (click)="onSubmit(adduserDetails)" [disabled]="showbutton()" class="button blue" type="button">
      Save
    </button>
  </div>
